// const thanksText = `დიდი მადლობა რო ითამაშეთ ჩემი თამაში!
// აგრეთვე თქვენი ფინანსური დახმარება პროექტის განვითარებას შველის
// თუ გნებავთ უფრო ხარისხიანი თამაშები საქართველოს ისტორიაზე, ჩემი ფეისბუქის ჯგუფში შედით და შემომთავაზეთ თქვენი სურვილები.
//
//   თქვენი სურვილების მიხედვით გავაკეთებ თამაშებს


//არაგველებმა გმირულად იბრძოდნენ, მაგრამ არც ერთი არ გადარჩა იმ ბრძოლაში


export const TEXTS = {
  startBattle: 'ბრძოლის დაწყება',

  amount: 'რაოდენობა',
  erekleSaved: 'მეფე გადავარჩინეთ!!',
  winTimeForErekle: 'მოიგე დრო რო მეფე ერეკლე ანანურში გაიქცეს',

  lostButErekleRunAway: 'დავმარცხდით, მაგრამ მეფე გადავარჩინეთ!',
  quitBtnText: 'გასვლა',

  failedToSaveErekle: 'მეფე ვერ გადავარჩინეთ',
  failedToSaveErekleAlternativeHistory: 'მთლიანი საქართველო სპარსელების ხელში ჩავარდა. ყველა ქალაქი გაანადგურეს და გაამაჰმადიანეს...',

  restart: 'ხელახლა',

  aragveliansDiedAll: 'არაგველებმა გმირულად იბრძოდნენ, მაგრამ არც ერთმა არ გადარჩა იმ ბრძოლაში',
  thanksForPlayingMyGame: 'მადლობა რო ითამაშეთ ჩემი თამაში!',

  next: 'შემდეგი',
  wannaSeeMoreGames: 'თუ გნებავთ უფრო ხარისხიანი თამაშები საქართველოს ისტორიაზე, ჩემი ფეისბუქის ჯგუფში შედით და შემომთავაზეთ თქვენი სურვილები.',

  aragvelianPreStory: `1795წ აღა მაჰმად ხანმა 35000 სპარსული ჯარით შემოიჭრა თბილისში. 


მის წინააღმდეგ 5000 მეომარი ებრძოდა ერეკლე II-ს მეთაურობით


3 დღე ვებრძოდით მრავალრიცხოვან მტერს, მაგრამ მესამე დღეს ალყა დაგვარტყეს სპარსელებმა...


მეფის და ჯარის გადარჩენის მიზნით 300 არაგველი გზა გადაუკეტეს სპარსელებს და დაიფიცეს



ან გაიმარჯონ, ან მოკვდნენ…`,
  battleEndText:
    `კრწანისის ბრძოლაში სპარსელებმა 15000 ჯარისკაცი დაკარგეს.

მეფე ერეკლემ და 150 ჯარისკაცმა დატოვეს თბილისი, რომელიც სპარსელებმა 9 დღეში სრულიად გაანადგურეს


რუსებმა, რომლებსაც ტრაქტატი ავალებდა საქართველოს დაცვას, მარტო 19 დეკემბერს ომი გამოუცხადეს ირანს

ისინი დერბენტი და ბაქო აიღეს, მაგრამ იმპერატორ პავლეს თქმით ომი შეწყვიტეს და ჯარი დააბრუნეს რუსეთში.

აღა მაჰმად ხანს 2 წლის შემდეგ მოკლეს`,

  thanksText: `ვიცი რომ კიდე ბევრი რამ არის გასაკეთებელი რომ ნამდვილად ისიამოვნოთ ამ თამაშით და ვეცდები შეცდომების შესწორებას

ტექნიკური მხრიდან მინდა უფრო კარგი ბრძოლის სიმულაცია გავაკეთო, იმიტომ რო ეხლა ის ძალიან სწრაფად მთავრდება, და არავითარ მოქმედებებს აზრი არ აქვს.

`
}